// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"238":"f63ee0755e368356","495":"a332b2e948edfa5f","776":"cb76a490c5c7df51"}[chunkId] + ".css";
};